import styled, { css } from 'styled-components';
const footerStyles = () => css `
	display: flex;
	flex-direction: column;
`;
export const StyledFooter = styled.footer `
	${footerStyles}
`;
